import { render, staticRenderFns } from "./todoToday.vue?vue&type=template&id=c4448674&scoped=true&"
import script from "./todoToday.vue?vue&type=script&lang=js&"
export * from "./todoToday.vue?vue&type=script&lang=js&"
import style0 from "./todoToday.vue?vue&type=style&index=0&id=c4448674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4448674",
  null
  
)

export default component.exports